import isEmptyObject from '../../src/helpers/is-empty-object';
import { ALL, MA, MASTERCARD, VISA } from '../constants/partnering-networks';
import collapsedLogger from './collapsed-logger';
import OrchCustomData from './orch-custom-data';

/* returns array of unloaded sdks from orchestartion
 * @param  {obj} futSRCNetworks - supported fut networks
 * @return {object} unloadedSdks - return an array unloaded Sdks
*/
const getUnloadedSdks = futSRCNetworks => {
  const loadedSdks = OrchCustomData.srcSdks?.loadedSdk ?? null;
  const unloadedSdks = [];
  const netWorksArray = [];
  //In case if futSRCNetworks getting as 'ALL', no need to unload any sdk
  if (futSRCNetworks && futSRCNetworks.length === 1 && futSRCNetworks[0].toUpperCase() === ALL) {
    collapsedLogger('UnloadSdk List =>', unloadedSdks);
    return unloadedSdks;
  }
  if (futSRCNetworks && futSRCNetworks.length > 0) {
    //BE might be sending the networks as mastercard, amex etc.
    //match and store as we cached current network instances
    futSRCNetworks.filter(item => {
      const network = item.toUpperCase();
      if (network == MA || network == MASTERCARD) {
        netWorksArray.push(MA);
      } else {
        netWorksArray.push(network);
      }
    });
  }
  if (!isEmptyObject(netWorksArray)) {
    //get a list of sdks thats not part of initial config
    Object.keys(loadedSdks).forEach(sdk => {
      if (!netWorksArray.includes(sdk) && sdk !== VISA) {
        unloadedSdks.push(sdk);
      }
    });
  }
  collapsedLogger('UnloadSdk List =>', unloadedSdks);
  return unloadedSdks;
};

export default getUnloadedSdks;
